import React from 'react';
import PropTypes from 'prop-types';
import ContentBox from '../../layout/component/ContentBox';
import Row from '../../bootstrap/component/Row';
import Column from '../../bootstrap/component/Column';
import Select from "../../form/component/Select";
import TextArea from "../../form/component/TextArea";
import LabelInput from "../../form/component/LabelInput";
import {lifecycle} from "recompose";
import Input from "../../form/component/Input";
import BlockUi from "react-block-ui";
import {PARTIAL_INVOICE_CORRECTION_CONTAINER} from "../../process/ui-definition/process-ui";
import currentUserHasAccess from "../../../util/widget-helper";
import ValidationMessageList from "../../validation/component/ValidationMessageList";

const PartialInvoiceCorrectionWidget = ({ salesOrderList, changePartialRefundData, partialRefundData, savePartialRefundData, fetching, validationMessageList}) => {

    if (!currentUserHasAccess(PARTIAL_INVOICE_CORRECTION_CONTAINER)) {
        return null;
    }

    const selectedSalesOrder = salesOrderList.find(salesOrder => salesOrder.id === partialRefundData.salesOrderId)
    const salesOrderType = selectedSalesOrder ? selectedSalesOrder.type : '';

    const salesOrderDropdown = [{id: '', value: 'Select'}].concat(salesOrderList.map(salesOrder => {
        return {id: salesOrder.id, value: salesOrder.referenceNumber}
    }))

    return (
        <BlockUi tag="div" blocking={fetching}>
            <ContentBox title="Partial Refund Information">
                <Row top="M">
                    <Column size={6}>
                        <table className="process-info-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <LabelInput label="Sales order reference">
                                            <Select object={partialRefundData}
                                                name="salesOrderId"
                                                valueList={salesOrderDropdown}
                                                onChange={changePartialRefundData}
                                            />
                                        </LabelInput>
                                    </td>
                                    <td>
                                        <label style={{textTransform: "capitalize",margin: "20px 0 0 5px"}}>{salesOrderType}</label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={2}>
                        <table className="process-info-table">
                            <tbody>
                            <tr>
                                <td>
                                    <LabelInput label="Correction Invoice Amount">
                                        <Input name="amount" type="number" object={partialRefundData} onChange={changePartialRefundData} pattern="^(\d+)(,\d{1,2}|.\d{1,2})?$" max={selectedSalesOrder ? selectedSalesOrder.brutPrice.toFixed(2) / 100 : null} />
                                    </LabelInput>
                                </td>
                                <td>
                                    <label style={{textTransform: "capitalize",margin: "20px 0 0 5px"}}>{selectedSalesOrder ? selectedSalesOrder.currency : ''}</label>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={2}>
                        <LabelInput label="Number of products">
                            <Select
                                object={partialRefundData}
                                name="numberOfProducts"
                                valueList={[...Array(20).keys()].map(i => {
                                    return {id: i + 1, value: i + 1}
                                })}
                                onChange={changePartialRefundData}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={12}>
                        <LabelInput label="Reason for correction invoice">
                            <TextArea name="reason" object={partialRefundData} onChange={changePartialRefundData} />
                        </LabelInput>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={2}>
                        <button
                            className="btn btn-primary"
                            onClick={savePartialRefundData}>
                            Save information
                        </button>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={12}>
                        <ValidationMessageList validationMessageList={validationMessageList}/>
                    </Column>
                </Row>
            </ContentBox>
        </BlockUi>
    )
}

PartialInvoiceCorrectionWidget.propTypes = {
    salesOrderList: PropTypes.array.isRequired,
    partialRefundData: PropTypes.object.isRequired,
    validationMessageList: PropTypes.array,
    changePartialRefundData: PropTypes.func,
    savePartialRefundData: PropTypes.func,
    fetching: PropTypes.bool,
}

export default lifecycle({
    componentDidMount () {
        this.props.getRefundableSalesOrderList()
        this.props.getPartialRefundData()
    },
})(PartialInvoiceCorrectionWidget)




// WEBPACK FOOTER //
// ./src/modules/partial-refund/component/PartialInvoiceCorrectionWidget.js